import axios from 'axios'
import config from '@/store/config.js'

const baseUrl = config.kakao.baseUrl
const restApiKey = config.kakao.restApiKey
const searchAddress = address => {
  return new Promise((resolve, reject) => {
    axios.get(`${baseUrl}/v2/local/search/address.json?query=${address}`, {
      headers: { Authorization: restApiKey }
    }).then(res => {
      if (res.status === 200) resolve(res.data)
      else reject(res)
    })
  })
}

export { searchAddress }



// WEBPACK FOOTER //
// ./src/kakao/index.js